var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67674 42.812L1.22205 49.9601L0.0743952 53.2994C-0.300036 54.3889 0.839497 55.4096 2.05591 55.0741L5.78411 54.0462L13.765 51.8476L3.67674 42.812Z",
    fill: "#DC8744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78203 54.0461L2.05383 55.074C0.837419 55.4094 -0.301983 54.3888 0.0724483 53.2993L1.2201 49.96L5.78203 54.0461Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71914 47.329L50.75 9.68311L45.7062 5.16553L3.67536 42.8114L8.71914 47.329Z",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7621 51.8466L55.793 14.2007L50.7492 9.68311L8.71834 47.329L13.7621 51.8466Z",
    fill: "#F6C358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7971 14.1989L45.709 5.16329L50.7428 0.654649C51.3815 0.0825648 52.417 0.0825648 53.0556 0.654649L60.8308 7.61866C61.4695 8.19075 61.4695 9.11826 60.8308 9.69023L55.7971 14.1989Z",
    fill: "#E56353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5217 18.0285L53.2031 16.5225L43.1149 7.48673L41.4334 8.99275L51.5217 18.0285Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1564 21.0392L49.8379 19.5332L39.7497 10.4975L38.0682 12.0035L48.1564 21.0392Z",
    fill: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.3095,
    height: 54.9133,
    fill: "white",
    transform: "translate(0 0.225586)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ecd10f9a40cd6274cc577462fa1274c6.svg";
export { ForwardRef as ReactComponent };